import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogConstants } from '../../app-core/constants/common-constants';

@Component({
	selector: 'app-update-dialog',
	templateUrl: './update-dialog.component.html',
	styleUrl: './update-dialog.component.scss'
})
export class UpdateDialogComponent {

	dialogConstants: typeof DialogConstants = DialogConstants;
	constructor(
		public dialogRef: MatDialogRef<UpdateDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { message: string }
	) { }

	onNoClick(): void {
		this.dialogRef.close('no');
	}

	onYesClick(): void {
		this.dialogRef.close('yes');
	}
}
